<div class="header-bottom">
  <ng-container *ngTemplateOutlet="verificationBadge"></ng-container>

  <div class="header-text-wrapper">
    <div class="profile">
      <avatar-list
        class="avatar-list"
        [model]="avatarsList"
        tooltipHeader="SHARED WITH"
        [spreadAvatarsCount]="3"
        [tooltipLimit]="99"
        [sizeAvatarTooltip]="'16px'"
      ></avatar-list>
    </div>
    <div class="header-text-container">
      <div class="header-text" [pTooltip]="publishedTimeTooltip" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
        {{ headerMessage }}
      </div>
      <div *ngIf="!!views" class="header-text">
        {{ viewsInfo }}
      </div>
    </div>
  </div>
</div>

<ng-template #verificationBadge>
  <div
    *ngIf="showVerificationIndications"
    class="verification-status"
    [pTooltip]="verificationTime"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
    (click)="openVerificationDetails()"
  >
    <u-icon class="icon" [model]="verificationIcon" [styles]="{ fontSize: '14px' }"> </u-icon>
    <span>{{ isVerified ? 'Verified' : 'Unverified' }}</span>
  </div>
</ng-template>
